import React from 'react';
import PropTypes from 'prop-types';
import { Avatar } from '@paypalcorp/pp-react';

function styleInject(css, ref) {
  if (ref === void 0) ref = {};
  var insertAt = ref.insertAt;
  if (!css || typeof document === 'undefined') {
    return;
  }
  var head = document.head || document.getElementsByTagName('head')[0];
  var style = document.createElement('style');
  style.type = 'text/css';
  if (insertAt === 'top') {
    if (head.firstChild) {
      head.insertBefore(style, head.firstChild);
    } else {
      head.appendChild(style);
    }
  } else {
    head.appendChild(style);
  }
  if (style.styleSheet) {
    style.styleSheet.cssText = css;
  } else {
    style.appendChild(document.createTextNode(css));
  }
}

var css_248z = "div.styles-module_anonymous__iDOF8 {\n  background-color: #005400 !important;\n}\n.styles-module_anonymous__iDOF8 svg:first-of-type {\n  color: #d4f490;\n}\n";
var styles = {"anonymous":"styles-module_anonymous__iDOF8"};
styleInject(css_248z);

function extractUserInitials(userName) {
  // split the names using space as delimiter
  var splitNames = userName.split(/ +/g).filter(function (e) {
    return e;
  });
  // first name - straight forward
  var firstName = splitNames.length > 0 ? splitNames[0] : null;
  // last name - if user has middle name, consider last element as last name
  var lastName = splitNames.length > 1 ? splitNames[splitNames.length - 1] : null;
  var initials;
  if (firstName) {
    initials = firstName[0];
  }
  if (lastName) {
    initials = "".concat(initials).concat(lastName[0]);
  }
  return initials;
}

function DonorAvatar(_ref) {
  var _ref$isAnonymousAvata = _ref.isAnonymousAvatar,
    isAnonymousAvatar = _ref$isAnonymousAvata === void 0 ? false : _ref$isAnonymousAvata,
    name = _ref.name,
    photo = _ref.photo,
    color = _ref.color,
    className = _ref.className,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? 'sm' : _ref$size;
  return /*#__PURE__*/React.createElement(React.Fragment, null, isAnonymousAvatar ? /*#__PURE__*/React.createElement(Avatar, {
    generic: "profile",
    color: "green",
    size: size,
    className: className ? "".concat(styles.anonymous, " ").concat(className) : styles.anonymous
  }) : /*#__PURE__*/React.createElement(Avatar, {
    src: photo,
    initials: extractUserInitials(name),
    color: color,
    size: size,
    className: className ? className : {}
  }));
}
DonorAvatar.propTypes = {
  isAnonymousAvatar: PropTypes.bool,
  name: PropTypes.string,
  photo: PropTypes.string,
  color: PropTypes.string,
  theme: PropTypes.string,
  className: PropTypes.string,
  size: PropTypes.string
};

export { DonorAvatar };
